import { createBrowserHistory } from 'history';

import { logInfo } from './utils';

export const history = createBrowserHistory();

history.listen(logInfo);
